import type { FC } from 'react';

import { MetamaskRound } from '@uikit/icons/Metamask';
import { PasskeysRound } from '@uikit/icons/PassKeys';
import { TonBrandColor } from '@uikit/icons/TonBrandColor';

import { Solana } from '@ui/uikit/components/icons/poly/ecosystems/Solana';

export enum WalletConnectType {
  PASSKEY = 'Passkey',
  EVM = 'EVM',
  SOLANA = 'SOLANA',
  TON = 'TON',
}

export const WALLET_CONNECT_TYPES = [
  WalletConnectType.PASSKEY,
  WalletConnectType.EVM,
  WalletConnectType.SOLANA,
  WalletConnectType.TON,
];

type WalletsConfig = Record<
  WalletConnectType,
  {
    Icon: FC;
    label: string;
    connectButtonText: string;
  }
>;

export const WALLETS_CONFIG: WalletsConfig = {
  EVM: {
    Icon: MetamaskRound,
    label: 'EVM Wallet',
    connectButtonText: 'Connect',
  },
  Passkey: {
    Icon: PasskeysRound,
    label: 'Passkeys Wallet',
    connectButtonText: 'Create',
  },
  TON: {
    Icon: TonBrandColor,
    label: 'Ton Wallet',
    connectButtonText: 'Connect',
  },
  SOLANA: {
    Icon: Solana,
    label: 'Solana Wallet',
    connectButtonText: 'Connect',
  },
};
